import React, { Component, useContext } from 'react';
import { TopBar } from '../common/TopBar';
import { Sidebar } from '../common/Sidebar';
import { Dropdown } from 'semantic-ui-react';
import axios from 'axios';
import {AppContext} from '../../context/app/appContext';
import {FileUpload} from './iconUpload';
import UpdateMerchant from './UpdateMerchant';
import {AddBlog} from './AddBlog';
import {Waitlist} from './Waitlist';
import {PollAddGPT} from './PollAddGPT';


class MySuperPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            providerName: '',
            icon: '',
            price: '',
            categories: [],
            editablePrice: false,
            merchantName: [],
            merchantNetworkId: []
        }
    }
    componentDidMount() {
        console.log(this.state)
        // const appContext = useContext(AppContext);

    }
    async savePerk() {
        var token = localStorage.getItem('accessToken')
        const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
        // const baseURL = "https://stgapi.perkfix.com";
        console.log("access token = ", token)
        await axios.post(baseURL + '/perks/create', this.state, {
            headers: {
                Authorization: "Bearer " + token
            }
        })
        console.log("Perk Saved = ", this.state)
        // window.location.reload(false)
    }
    pushMerchantName0(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantName[0] = value
            this.setState(newState)
        }

    }
    pushMerchantName1(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantName[1] = value
            this.setState(newState)
        }

    }
    pushMerchantName2(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantName[2] = value
            this.setState(newState)
        }

    }
    pushMerchantName3(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantName[3] = value
            this.setState(newState)
        }

    }
    pushMerchantName4(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantName[4] = value
            this.setState(newState)
        }

    }
    pushMerchantName5(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantName[5] = value
            this.setState(newState)
        }

    }
    pushMerchantId0(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[0] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId1(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[1] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId2(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[2] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId3(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[3] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId4(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[4] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId5(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[5] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId6(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[6] = (value)
            this.setState(newState)
        }

    }
    pushMerchantId7(value) {
        if (value) {
            var newState = { ...this.state }
            newState.merchantNetworkId[7] = (value)
            this.setState(newState)
        }

    }
    render() {
        return (
            <div id="app">
                <TopBar />
                {/* add merchant details */}
                <div className="inline fields">
                    <div className="field four wide" >
                        <label>Updating an existing Merchant? click here. </label>
                    </div>
                    <div className="field eight wide">
                        <button
                            className="ui button "
                            onClick={() => this.setState({ update: "update" })}>Update</button>
                    </div>
                </div>
                <div className="inline fields">
                    <div className="field four wide">
                        <label>Add a new Merchant? click here. </label>
                    </div>
                    <div className="field eight wide">
                        <button className="ui button " onClick={() => this.setState({ update: "add" })}>Add</button>
                    </div>
                </div>
                <div className="inline fields">
                    <div className="field four wide">
                        <label>Upload a blog. </label>
                    </div>
                    <div className="field eight wide">
                        <button className="ui button " onClick={() => this.setState({ update: "blog" })}>Blog</button>
                    </div>
                </div>
                <div className="inline fields">
                    <div className="field four wide">
                        <label>Check WaitList? </label>
                    </div>
                    <div className="field eight wide">
                        <button className="ui button " onClick={() => this.setState({ update: "waitlist" })}>Waitlist</button>
                    </div>
                </div>
                <div className="inline fields">
                    <div className="field four wide">
                        <label>Add poll details for GPT training data </label>
                    </div>
                    <div className="field eight wide">
                        <button className="ui button " onClick={() => this.setState({ update: "poll" })}>Poll GPT</button>
                    </div>
                </div>
                <form className="ui form">
                    {/* <div className="inline fields">
                        <div className="field four wide" >
                            <label>Updating an existing Merchant? click here. </label>
                        </div>
                        <div className="field eight wide">
                        <button
                             className="ui button "
                            onClick={() => this.setState({ update: "update" })}>Update</button>
                        </div>
                    </div>
                    <div className="inline fields">
                        <div className="field four wide">
                            <label>Add a new Merchant? click here. </label>
                        </div>
                        <div className="field eight wide">
                            <button className="ui button " onClick={() => this.setState({ update: "add" })}>Add</button>
                        </div>
                    </div> */}
                    {/* <button onClick={() => this.setState({ update: "update" })}>Update</button> */}

                    {/* <div>Add a new Merchant? click here.
                <button onClick={() => this.setState({ update: "add" })}>Add</button>
                    </div> */}
                </form>


                {this.state.update === "update" ? <UpdateMerchant /> : this.state.update === "blog" ? <AddBlog/> : this.state.update === "waitlist" ? <Waitlist/>: this.state.update === "poll" ? <PollAddGPT/> :
                    <div>
                        <div style={{ backgroundColor: "#fafafa" }}>
                            <hr />
                            <h3 style={{ textAlign: "center" }}>Add Merchants</h3>
                            <hr />
                        </div>

                        <br></br>
                        <br></br>

                        <form className="ui form" style={{ marginLeft: "30px" }}>
                            {/* <div className="field three wide">
                            </div> */}

                            <div className="inline fields">
                                <div className="field three wide">
                                    <label>Name of the perk:</label>
                                </div>
                                <div className="field eight wide">
                                    <input type="text" required name="perkName" placeholder="Enter the Perk Name" onChange={(e) => this.setState({ providerName: e.target.value })} />
                                </div>
                            </div>
                            <div className="inline fields">
                                <div className="field three wide">
                                    <label>Name of the Icon:</label>
                                </div>
                                <div className="field eight wide">
                                    <input type="text" required name="iconName" placeholder="Enter Name of the Icon" onChange={(e) => this.setState({ icon: e.target.value })} />
                                </div>
                            </div>
                            <div className="inline fields">
                                <div className="field three wide">
                                    <label>Price of the perk:</label>
                                </div>
                                <div className="field eight wide">
                                    <input type="text" required name="perkPrice" placeholder="Enter the Price" onChange={(e) => this.setState({ price: e.target.value })} />
                                </div>
                            </div>
                            <div className="inline fields" >
                                <div className="field three wide">
                                    <label>Name of the Merchant:</label>
                                </div>
                                <div className="field eight wide " style={{ display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
                                    <input type="text" required name="merchantName" placeholder="Enter Merchant Name" onChange={(e) => this.pushMerchantName0(e.target.value)} />
                                    <input type="text" name="merchantName" placeholder="Enter Merchant Name" onChange={(e) => this.pushMerchantName1(e.target.value)} />
                                    <input type="text" name="merchantName" placeholder="Enter Merchant Name" onChange={(e) => this.pushMerchantName2(e.target.value)} />
                                    <input type="text" name="merchantName" placeholder="Enter Merchant Name" onChange={(e) => this.pushMerchantName3(e.target.value)} />
                                    <input type="text" name="merchantName" placeholder="Enter Merchant Name" onChange={(e) => this.pushMerchantName4(e.target.value)} />
                                    <input type="text" name="merchantName" placeholder="Enter Merchant Name" onChange={(e) => this.pushMerchantName5(e.target.value)} />

                                </div>
                            </div>
                            <div className="inline fields" >
                                <div className="field three wide">
                                    <label>Merchant Network ID:</label>
                                </div>
                                <div className="field eight wide " style={{ display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
                                    <input type="text" required name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId0(e.target.value)} />
                                    <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId1(e.target.value)} />
                                    <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId2(e.target.value)} />
                                    <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId3(e.target.value)} />
                                    <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId4(e.target.value)} />
                                    <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId5(e.target.value)} />
                                    <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId6(e.target.value)} />
                                    <input type="text" name="networkID" placeholder="Enter Network ID" onChange={(e) => this.pushMerchantId7(e.target.value)} />

                                </div>

                            </div>
                            <div className="inline fields">
                                <div className="field three wide">
                                    <label>Is this price editable?</label>
                                </div>
                                <Dropdown

                                    placeholder='Multiple Choice'
                                    multiple
                                    fluid
                                    search
                                    selection
                                    className="teamDropDown"
                                    options={[{ key: 1, value: 1, text: "true" }, { key: 2, value: 2, text: "false" }]}
                                    // value={selectedTeams}
                                    onChange={(t, d) => { d.value === 'true' ? this.setState({ editablePrice: true }) : this.setState({ editablePrice: false }) }}
                                />

                            </div>
                            <div className="inline fields">
                                <div className="field three wide">
                                    <label>Categories:</label>
                                </div>
                                <Dropdown
                                    placeholder='Multiple Choice'
                                    multiple
                                    fluid
                                    search
                                    selection
                                    className="teamDropDown"
                                    options={[{ key: 1, value: "Popular", text: "Popular" }, { key: 2, value: "Wellness", text: "Wellness" }, { key: 3, value: "Productivity", text: "Productivity" }, { key: 4, value: "Training", text: "Training" }, { key: 5, value: "Lifestyle", text: "Lifestyle" }, { key: 6, value: "Entertainment", text: "Entertainment" }, { key: 7, value: "Commute", text: "Commute" }]}
                                    // value={selectedTeams}
                                    onChange={(t, d) => {
                                        console.log("dd change =", d.value)

                                        this.setState({ categories: d.value })

                                    }}
                                />
                            </div>
                            <div className="inline fields">
                                <div className="field three wide">
                                    <label>ICON UPLOAD HERE</label>
                                </div>


                                <FileUpload imageName={this.state.icon} />

                            </div>

                            <div>
                                Algolia Entries: Please enter keywords separated by a comma in the given format eg. sleep,anxiety,performance,yoga,calm,sounds,stress,meditation,happiness,peace,sad,happy,joy,mental,tired,focus
                    <div>NOTE: do not add spaces</div>
                                <input type="text" className="perkInput" name="perkKeywords" onChange={(e) => this.setState({ perkKeywords: e.target.value.trim() })}></input>

                            </div>

                            <div className="perk-buttons" style={{
                                marginTop: "20px"
                            }}>
                                < button className="ui button " type="submit" onClick={() => window.location.reload(false)}>Cancel</button>
                                <button className="ui button " type="submit" onClick={() => this.savePerk()}>Publish Perk</button>

                            </div>
                            <br></br>



                        </form>

                    </div >
                }



            </div>

        );
    }
}


{/* <div className="perkAdd"> */ }
{/* <div className ="perkName"> Add Merchants:</div>
                <div className ="perkName"> Name of the perk: 
                    <input type="text" className="perkInput" name="perkName" onChange={(e)=>this.setState({providerName: e.target.value})}></input>
                </div> */}
{/* <div className="perkName"> Name of the icon:
                    <input type="text" className="perkInput" name="iconName" onChange={(e) => this.setState({ icon: e.target.value })}></input>
                            </div> */}
{/* <div className="perkName"> Price for the perk :
                    <input type="text" className="perkInput" name="perkPrice" onChange={(e) => this.setState({ price: e.target.value })}></input>
                            </div> */}

{/* <div className="perkName" style={{ display: "flex", flexDirection: "column", justifyContent: "space-around" }}> Name of the Merchant :
                    <input type="text" className="perkInput" name="merchantName" onChange={(e) => this.pushMerchantName0(e.target.value)}></input>
                                <input type="text" className="perkInput" name="merchantName" onChange={(e) => this.pushMerchantName1(e.target.value)}></input>
                                <input type="text" className="perkInput" name="merchantName" onChange={(e) => this.pushMerchantName2(e.target.value)}></input>
                                <input type="text" className="perkInput" name="merchantName" onChange={(e) => this.pushMerchantName3(e.target.value)}></input>
                                <input type="text" className="perkInput" name="merchantName" onChange={(e) => this.pushMerchantName4(e.target.value)}></input>
                                <input type="text" className="perkInput" name="merchantName" onChange={(e) => this.pushMerchantName5(e.target.value)}></input>
                            </div> */}
{/* <div className="perkName" style={{ display: "flex", flexDirection: "column", justifyContent: "space-around" }}> Merchant Network ID :
                    <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId0(e.target.value)}></input>
                                <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId1(e.target.value)}></input>
                                <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId2(e.target.value)}></input>
                                <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId3(e.target.value)}></input>
                                <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId4(e.target.value)}></input>
                                <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId5(e.target.value)}></input>
                                <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId6(e.target.value)}></input>
                                <input type="text" className="perkInput" name="networkID" onChange={(e) => this.pushMerchantId7(e.target.value)}></input>
                            </div> */}
{/* <div className="perkName"> Is the price editable?
                    <Dropdown

                                    placeholder='Multiple Choice'
                                    multiple
                                    fluid
                                    search
                                    selection
                                    className="teamDropDown"
                                    options={[{ key: 1, value: 1, text: "true" }, { key: 2, value: 2, text: "false" }]}
                                    // value={selectedTeams}
                                    onChange={(t, d) => { d.value === 'true' ? this.setState({ editablePrice: true }) : this.setState({ editablePrice: false }) }}
                                />
                            </div> */}
{/* <div className="perkName"> Categories:
                    <Dropdown

                                    placeholder='Multiple Choice'
                                    multiple
                                    fluid
                                    search
                                    selection
                                    className="teamDropDown"
                                    options={[{ key: 1, value: "Popular", text: "Popular" }, { key: 2, value: "Wellness", text: "Wellness" }, { key: 3, value: "Productivity", text: "Productivity" }, { key: 4, value: "Training", text: "Training" }, { key: 5, value: "Lifestyle", text: "Lifestyle" }, { key: 6, value: "Entertainment", text: "Entertainment" }, { key: 7, value: "Commute", text: "Commute" }]}
                                    // value={selectedTeams}
                                    onChange={(t, d) => {
                                        console.log("dd change =", d.value)

                                        this.setState({ categories: d.value })

                                    }}
                                />
                            </div> */}
{/* <div>ICON UPLOAD HERE</div>
                            <FileUpload imageName={this.state.icon} /> */}
{/* <div>Algolia Entries: Please enter keywords separated by a comma in the given format eg. sleep,anxiety,performance,yoga,calm,sounds,stress,meditation,happiness,peace,sad,happy,joy,mental,tired,focus
                    <div>NOTE: do not add spaces</div>
                                <input type="text" className="perkInput" name="perkKeywords" onChange={(e) => this.setState({ perkKeywords: e.target.value.trim() })}></input>
                            </div> */}


{/* </div> */ }
{/* <div className="perk-buttons">
                            <button className="cancel-button" onClick={() => window.location.reload(false)}>Cancel</button>
                            <button className="add-choices-button" onClick={() => this.savePerk()}>Publish Perk</button>

                        </div> */}

export default MySuperPage;